import Store from 'apps/teacher/store';
import { dispatchAvoEvent } from '..';
import { AVO_EVENT_NAMES } from '../eventNames';

interface IPlayableClickedProps {
    recommendedRailName: any;
    recommendedTileRank: any;
    recommendedRailRank: any;
    gameType: string;
    gameCode: string;
    from: string;
    gameEngine: string;
    contentType: string;
    playableCode: string;
    recommendedTileName: Array<string>;
    playableName: string;
    playableType: string;
    pageName: string;
    assignmentType: string;
    tabName?: string;
    assessmentAvailable?: string;
}

const sendEventUsingAvo = (props: any = {}) => {
    const initParams = {
        //@ts-ignore
        klassGrade: window.KLASS_GRADE?.code ?? null, //@ts-ignore
        currentGrade: window.KLASS_GRADE?.code ?? null, //@ts-ignore
        subjectCode: window.KLASS_DETAIL?.id ? "Math" : '', //@ts-ignore
        klass: window.KLASS_DETAIL,
    };

    dispatchAvoEvent(props, initParams);
};

const ErrorMessageDisplayedB2b = (valueName: string): void => {
    sendEventUsingAvo({eventName: AVO_EVENT_NAMES.errorMessageDisplayedB2b, props: {valueName}});
}

const firePlayableClickedEvent = (isTeacher: boolean, props: IPlayableClickedProps): void => {
    const {currentKlass} = Store.getState();
    const initParams: any = {
        //@ts-ignore
        grade: window.eventInitProps?.klassGrade?.toLowerCase() || currentKlass?.klass?.gradeCode?.toLowerCase(),
        subject: (window.eventInitProps?.subjectCode || currentKlass?.current_course?.subject_code) ? "math" : '',
    };
    if(!isTeacher){
        initParams.mathGrade = window.eventInitProps?.currentGrade?.toLowerCase() || currentKlass?.current_course?.grade_code || "NA";
        initParams.elaGrade = window.eventInitProps?.currentGrade?.toLowerCase() || currentKlass?.current_course?.grade_code || "NA";
    }
    props.recommendedRailName = [props.recommendedRailName || ""];
    props.recommendedTileRank = [props.recommendedTileRank >= 0 ? props.recommendedTileRank : -1];
    props.recommendedRailRank = [props.recommendedRailRank >= 0 ? props.recommendedRailRank : -1];
    
    sendEventUsingAvo({eventName: isTeacher ? AVO_EVENT_NAMES.playableClickedTeacher : AVO_EVENT_NAMES.playableClicked, props: {...initParams, ...props}, teacherCoreProperties: isTeacher, studentCoreProperties: !isTeacher});
}

const DefaultEvents = {
    ErrorMessageDisplayedB2b,
    firePlayableClickedEvent
}

export default DefaultEvents;